import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { type LOCALE } from '../../i18n'

import { recommendationAccessorGetUnderscoreLocale } from './recommendationAccessorGetUnderscoreLocale'

export const recommendationAccessorGetLocalizedProductBasePriceUnit = ({
  locale,
  product,
}: {
  locale: LOCALE
  product: GkAirRecommendedProductDataWeb
}): string | undefined =>
  product[
    `base_price_unit_${recommendationAccessorGetUnderscoreLocale(locale)}`
  ]
